let getSettings = () =>{
    return {
        api:"https://sociagramz.herokuapp.com"                                    //"https://loginp.herokuapp.com"5 https://sociagramz.herokuapp.com//http://localhost:3004//*https://sociagramz.herokuapp.com
    }
}


export default getSettings()